import { ErrorResponse, FetchRegisterToB2b, FetchVerifyByPhoneToB2b } from "./interface"

import { httpClient } from "utils/infrastructure/httpClient"

export const fetchRegisterToB2b = ({
    company,
    phone,
    email,
    name,
}: {
    company: string
    phone: string
    email: string
    name: string
}) => {
    return httpClient.post<FetchRegisterToB2b & ErrorResponse>(
        `client/auth2/verification-code/register/b2b/send/${company}`,
        {
            phone,
            email,
            name,
        }
    )
}

export const fetchVerifyByPhoneToB2b = ({
    code,
    token,
    phone,
}: {
    code: string
    token: string
    phone: string
}) => {
    return httpClient.post<FetchVerifyByPhoneToB2b & ErrorResponse>(
        `client/auth2/verification-code/verify/phone`,
        {
            verification_code: code,
            verification_token: token,
            phone,
        }
    )
}
